import { render, staticRenderFns } from "./ModalRemoveReportItem.vue?vue&type=template&id=6f760e3d&scoped=true"
import script from "./ModalRemoveReportItem.vue?vue&type=script&lang=js"
export * from "./ModalRemoveReportItem.vue?vue&type=script&lang=js"
import style0 from "./ModalRemoveReportItem.vue?vue&type=style&index=0&id=6f760e3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f760e3d",
  null
  
)

export default component.exports